// @flow
import { AuthActionTypes } from './constants';

import { APICore } from '../../helpers/api/apiCore';

const api = new APICore();

const INIT_STATE = {
    user: api.getLoggedInUser(),
    userLoggedIn: api.getLoggedInUser() ? true : false, //  add this
    loading: false,
};

const Auth = (state = INIT_STATE, action) => {
    switch (action.type) {
        case AuthActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        user: action.payload.data,
                        userLoggedIn: true,
                        loading: false,
                        getOTP: true,
                    };
                }
                case AuthActionTypes.SIGNUP_USER: {
                    return {
                        ...state,
                        loading: false,
                        userSignUp: true,
                    };
                }
                case AuthActionTypes.LOGOUT_USER: {
                    return {
                        ...state,
                        user: null,
                        loading: false,
                        userLogout: true,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        resetPasswordSuccess: action.payload.data,
                        loading: false,
                        passwordReset: true,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD_CHANGE: {
                    return {
                        ...state,
                        loading: false,
                        passwordChange: true,
                    };
                }
                case AuthActionTypes.MOBILE_VERIFICATION: {
                    return {
                        ...state,
                        mobileVerifySuccess: action.payload.data,
                        loading: false,
                        OTPs: true,
                    };
                }
                case AuthActionTypes.USER_VERIFICATION: {
                    return {
                        ...state,
                        mobileVerifySuccess: action.payload.data,
                        loading: false,
                        OTPs: true,
                    };
                }
                case AuthActionTypes.UPDATE_USER_AFTER_STATION_ADD:
                    return {
                        ...state,
                        user: { ...state.user, ...action.payload },
                    };

                default:
                    return { ...state };
            }

        case AuthActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        userLoggedIn: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.SIGNUP_USER: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        userSignUp: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        passwordReset: false,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD_CHANGE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        passwordChange: false,
                    };
                }
                case AuthActionTypes.MOBILE_VERIFICATION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        OTPs: false,
                    };
                }
                case AuthActionTypes.USER_VERIFICATION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        OTPs: false,
                    };
                }
                default:
                    return { ...state };
            }

        case AuthActionTypes.LOGIN_USER:
            return { ...state, loading: true, userLoggedIn: false };
        case AuthActionTypes.LOGOUT_USER:
            return { ...state, loading: true, userLogout: false };
        case AuthActionTypes.SIGNUP_USER:
            return { ...state, loading: true, userSignUp: false };
        case AuthActionTypes.FORGOT_PASSWORD:
            return { ...state, loading: true, passwordReset: false };
        case AuthActionTypes.MOBILE_VERIFICATION:
            return { ...state, loading: true, OTPs: false };
        case AuthActionTypes.USER_VERIFICATION:
            return { ...state, loading: true, OTPs: false };
        case AuthActionTypes.FORGOT_PASSWORD_CHANGE:
            return { ...state, loading: true, passwordChange: false };
        case AuthActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                userSignUp: false,
                userLoggedIn: false,
                passwordReset: false,
                passwordChange: false,
                OTPs: false,
                resetPasswordSuccess: null,
                mobileVerifySuccess: null,
            };
        default:
            return { ...state };
    }
};

export default Auth;
